import { scrollToElement } from '../scroll-to-element';

import OptionChooser from '../product-detail/option-chooser';
import DetailDropdowns from '../product-detail/detail-dropdowns';
import MainGallery from '../product-detail/main-product-gallery';
import AmountHandler from '../amount-handler';
import AvailabilityPopup from '../availability-popup';
import DescNavigation, { waitForImagesLoad } from '../desc-navigation';
import { on } from 'delegated-events';
import showPopup from '../modals';
import { sendViewedObject } from '../utils/algolia-attribution';


export default function () {
    MainGallery();
    OptionChooser();
    DetailDropdowns();
    AmountHandler();
    AvailabilityPopup();
    DescNavigation();
    ScrollToComments();
    CommentsFetcher();
    GpsrPopup();
    trackAlgoliaView();
    // VARIOUS BELOW
}

function trackAlgoliaView() {
    // Algolia objectID == OptionId (search_feed indexes by product_id, which is
    // our variant id). If we have attribution from a recent suggestion click,
    // sendViewedObject routes to viewedObjectIDsAfterSearch automatically.
    const optionEl = document.querySelector('[data-scope="addcart"] [data-optionid]');
    const optionId = optionEl ? optionEl.getAttribute('data-optionid') : null;
    if (optionId && optionId !== '-1') sendViewedObject(optionId);
}

on('click', '[data-cart-click]', () => {
    if (document.querySelector('.cart-disabled')) return;
    document.querySelector('.buy-button')?.click();
});

function IsMoreComments() {

    var mainContainer = document.getElementById("detail-comments");

    if (mainContainer) {
        var totalItems = +mainContainer.getAttribute("data-total-votes");
        var existingItems = mainContainer.querySelectorAll('article.comment').length;

        const moreButton = mainContainer.querySelector(".load-more-comments");
        moreButton.classList.remove('loading');

        if (totalItems <= existingItems) {
            moreButton.remove();
        }

    }
}

function CommentsFetcher() {


    on("click", ".load-more-comments", function (event) {
        this.classList.add('loading');

        var container = document
            .querySelector('.comments-list');
        var existingItemsCount = container
            .querySelectorAll('article.comment').length;

        fetch('/opinions/Fetch', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({
                existingCount: existingItemsCount,
                productId: +event.target.getAttribute("data-productId")
            }),
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        }).then(response => {
            if (!response.ok) throw new Error("Błąd pobierania");
            return response.text();
        }).then(html => {


            fetch('/opinions/FetchLdJson', {
                method: 'POST',
                credentials: 'same-origin',
                body: JSON.stringify({
                    existingCount: existingItemsCount,
                    productId: +event.target.getAttribute("data-productId")
                }),
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            })
                .then(response => response.json())
                .then(json => {

                    container.innerHTML += html;
                    IsMoreComments();

                   

                    const ldJsonScript = document.querySelector('script[type="application/ld+json"]');

                   
                    let ldJsonData = JSON.parse(ldJsonScript.textContent);

                    // Produkt wielowariantowy jest emitowany jako ProductGroup (opinie siedzą na grupie).
                    const productObj = ldJsonData.find(item => item['@type'] === 'Product' || item['@type'] === 'ProductGroup');

                    if (!productObj) {
                       
                        return;
                    }

                    productObj.review = productObj.review || [];

                    if (Array.isArray(json)) {
                        productObj.review = productObj.review.concat(json);
                    }

                   
                    ldJsonScript.textContent = JSON.stringify(ldJsonData, null, 2);

                    //console.log("Nowe LD+JSON złączone:", ldJsonScript.textContent);

                });


        })

    });

}
function ScrollToComments() {
    const scrollTrigger = document.querySelector("[data-scroll-to-comments]");
    if (!scrollTrigger) return;
    const target = document.querySelector('#detail-comments');
    if (!target) return;

    scrollTrigger.style.cursor = 'pointer';
    scrollTrigger.addEventListener('click', function () {
        waitForImagesLoad('#detail-description')
            .then(() => {
                scrollToElement(target, 36);
            });
    });
}


function GpsrPopup() {
    document.querySelectorAll('.gpsr-popup-trigger').forEach(button => {
        const content = document.querySelector(`[data-gpsr-content="${button.dataset.gpsrTarget}"]`);
        if (!content) return;

        button.addEventListener('click', () => {
            showPopup({
                header: button.dataset.gpsrHeader,
                body: `<div class="user-custom-content">${content.innerHTML}</div>`
            });
        })
    });
}